/* Load-order guard: this file is loaded from a section/snippet that renders EARLIER in
   the document than jquery.min.js in the footer script zone. Deferred scripts execute in
   document order, not load order, so without this wrapper the first jQuery/$ call here
   throws ReferenceError and kills the whole block.

   DOMContentLoaded fires only after every deferred script has run, so jQuery is guaranteed
   defined by then. Do not unwrap this. */
document.addEventListener('DOMContentLoaded', function () {
jQuery(document).ready(function ($) {
    

    let timeLeft = 4 * 60;

    function updateTimer() {
        let hours = Math.floor(timeLeft / 3600);
        let minutes = Math.floor((timeLeft % 3600) / 60);
        let seconds = timeLeft % 60;

        // format with leading zeros
        hours = String(hours).padStart(2, '0');
        minutes = String(minutes).padStart(2, '0');
        seconds = String(seconds).padStart(2, '0');

        $('.timer').text(minutes + ':' + seconds);

        if (timeLeft > 0) {
            timeLeft--;

           
        } else {
             // Open on hesitation timer or any trigger
                // $.magnificPopup.open({
                //     items: { src: '#hesitation-popup', type: 'inline' },
                //     mainClass: 'mfp-hesitation',
                //     removalDelay: 300,
                //     callbacks: {
                //         open: function () {
                //         // // Optional: animate sheet in
                //         // $('.hesitation-sheet').css({ transform: 'translateY(100%)', opacity: 0 });
                //         // setTimeout(function () {
                //         //     $('.hesitation-sheet').css({ transition: 'transform 0.4s cubic-bezier(.32,.72,0,1), opacity 0.3s', transform: 'translateY(0)', opacity: 1 });
                //         // }, 10);
                //         }
                //     }
                // });
        clearInterval(timerInterval);
        }
    }

    const timerInterval = setInterval(updateTimer, 1000);
    updateTimer(); // run immediately


    // The trust row used to be a phone-only marquee built here on load. It
    // now fits all four items in CSS (fon-b2g1.liquid, .b2g1-ups), so there
    // is nothing to build and nothing to break when the window is resized.


    // The buy widget's video plays in its own card (fon-b2g1.liquid,
    // .b2g1-vsl). The <mux-player> is already in the card; the footer loads
    // its library after page load, or on this very click if it has not yet.
    $(document).on('click', '[data-b2g1-vsl] .b2g1-vsl__poster', function () {
        var box = this.closest('[data-b2g1-vsl]');
        var player = box.querySelector('mux-player');
        if (!player) return;

        function play() {
            box.classList.remove('is-loading');
            box.classList.add('is-playing');
            player.muted = false;
            var p = player.play();
            // A browser that refuses sound without a fresh tap leaves the
            // player paused on its own controls, which is a fine fallback.
            if (p && p.catch) p.catch(function () {});
        }

        if (window.customElements && customElements.get('mux-player')) {
            play();
        } else if (window.customElements) {
            box.classList.add('is-loading');
            customElements.whenDefined('mux-player').then(play);
        }
    });


    // Week-by-week carousel dots (phone only; the rail itself is CSS
    // scroll-snap in fon-b2g1.liquid, .week-container).
    (function () {
        var rail = document.querySelector('.fon-b2g1-benefits .week-container');
        var dots = document.querySelectorAll('.fon-b2g1-benefits .week-dots button');
        if (!rail || !dots.length) return;
        var cards = rail.children;

        function current() {
            var best = 0, bestDist = Infinity;
            // The rail is position: relative, so a card's offsetLeft is its
            // place in the rail's content and does not move as it scrolls.
            for (var i = 0; i < cards.length; i++) {
                var d = Math.abs(cards[i].offsetLeft - cards[0].offsetLeft - rail.scrollLeft);
                if (d < bestDist) { bestDist = d; best = i; }
            }
            // The last card can never reach the left edge; at the end of the
            // rail it is the one in view.
            if (rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2) best = cards.length - 1;
            return best;
        }

        var ticking = false;
        rail.addEventListener('scroll', function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function () {
                ticking = false;
                var n = current();
                for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('active', i === n);
            });
        }, { passive: true });

        Array.prototype.forEach.call(dots, function (dot, i) {
            dot.addEventListener('click', function () {
                if (!cards[i]) return;
                rail.scrollTo({ left: cards[i].offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
            });
        });
    })();


    var b2g1 = {
        variables: {
            type : 'b2g1',
            selection : {},
        },
        init : function(){


            $(document).on('click','#btn-checkout.active',function(){
                $('[data-product="4"]').removeClass('d-none');
                $('[data-product="5"]').removeClass('d-none');
                $('#btn-checkout-b2g1').hide();
                $('#btn-checkout span').html('Keep Going — 2 More For Your Free Product');

                $('.chosen-products').removeClass('filled');

                $(this).removeClass('active');

                b2g1.variables.type = 'b3g2';
                $('.pick-products-container').removeClass('filled');

                   // Smooth scroll to #claim with 100px offset
                    $('html, body').animate({
                        scrollTop: $('#claim').offset().top - 100
                    }, 600);


                $('.b2g1-buy-card .top h2').html('Buy 3 - Get 2 Free');
            });

            
            $(document).on('click', '#btn-checkout-b2g1', function () {

                var $btn = $(this);
                var $btnSpan = $btn.find('span');
                var originalText = $btn.text();

                // Show loading state
                $btnSpan.text('Please wait...');
                $btn.prop('disabled', true);

                setTimeout(function () {
                    $btn.text(originalText);
                    $btn.prop('disabled', false);
                }, 500);

                var selection = b2g1.variables.selection;
                // selection = { variantId: quantity, variantId: quantity, ... }


                 buildCheckoutItems(selection);
                $.magnificPopup.open({
                    items: { src: '#checkout-popup', type: 'inline' },
                    mainClass: 'mfp-checkout',
                    removalDelay: 300,
                    closeBtnInside: true,
                    callbacks: {
                        
                    }
                });

                

            });
            $(document).on('click', '#cp-checkout-btn', function () {
                checkoutNow($(this));
            });


            // Checkout B3G3
            $(document).on('click', '#btn-checkout.b3g2', function () {

                 var $btn = $(this);
                var $btnSpan = $btn.find('span');
                var originalText = $btn.text();

                // Show loading state
                $btnSpan.text('Please wait...');
                $btn.prop('disabled', true);

                setTimeout(function () {
                    $btn.text(originalText);
                    $btn.prop('disabled', false);
                }, 500);


                var selection = b2g1.variables.selection;
                buildCheckoutItems(selection);
                $.magnificPopup.open({
                    items: { src: '#checkout-popup', type: 'inline' },
                    mainClass: 'mfp-checkout',
                    removalDelay: 300,
                    closeBtnInside: true,
                    callbacks: {
                        
                    }
                });


            });

            $(document).on('click', '#btn-hesitation-add', function () {

                // Reset qty values
                $('.qty-value').val(0);

                // Reset b2g1 variables
                b2g1.variables.type = 'b2g1';
                b2g1.variables.selection = {};

                // Reset UI
                $('.pick-products-container').removeClass('filled');

                

                var $choco = $('button[data-action="plus"][data-variant-id="52360138358968"]');
                var $vanilla = $('button[data-action="plus"][data-variant-id="52360138391736"]');

                $choco.trigger('click');         // 1st choco

                setTimeout(function () {
                    $choco.trigger('click');     // 2nd choco (after state settles)
                    $vanilla.trigger('click');   // 1× vanilla
                }, 100);
                
                // Smooth scroll to #claim with 100px offset
                $('html, body').animate({
                    scrollTop: $('#claim').offset().top - 100
                }, 600);

                // Close the popup
                $.magnificPopup.close();

            });
            


            $(document).on('click','.qty-picker button',function(){

                var currentQty = parseInt($(this).siblings('.qty-value').html());
                var btnMinus = $(this).parents('.qty-picker').find('[data-action="minus"]');


                var variantID = $(this).data('variant-id');



                var newQty = currentQty;
                var action = $(this).data('action');

                var limit = (b2g1.variables.type == 'b2g1') ? 3 : 5;

               

                switch (action){
                    case 'minus':
                        if (currentQty > 0){
                            newQty--;
                        }
                    break;
                    case 'plus':
                        if (b2g1.countTotalQty() < limit){
                            newQty++;
                        }
                    break;
                }

                //  alert(b2g1.countTotalQty() + ' ' + limit);



                // Set Selection
                b2g1.variables.selection[variantID] = newQty;

                if (newQty == 0){
                    delete b2g1.variables.selection[variantID];
                }
                
                
                // Btn Minus to activate or not
                if (newQty == 0){
                    btnMinus.removeClass('active');
                }else{
                    btnMinus.addClass('active');
                }

                $(this).siblings('.qty-value').html(newQty);

                if (limit == b2g1.countTotalQty()){
                    $('.pick-products-container').addClass('filled');
                    $('.chosen-products').addClass('filled');
                }else{
                    $('.pick-products-container').removeClass('filled');
                    $('.chosen-products').removeClass('filled');
                }
                

                // B3G2
                $('#btn-checkout-b2g1').hide();
                $('#btn-checkout').removeClass('active b3g2');
                $('.b2g1-add-on').hide();

                $('.product-pick').attr('step',b2g1.countTotalQty());


                switch (b2g1.countTotalQty()){
                    case 0:
                        $('#btn-checkout span').html('Choose Your First Product Above');
                    break;
                    case 1:
                        $('#btn-checkout span').html('Keep Going — 2 More For Your Free Product');
                    break;
                    case 2:
                        $('#btn-checkout span').html('Add 1 More To Unlock Your Free Product');


                        $('[data-product="4"]').addClass('d-none');
                        $('[data-product="5"]').addClass('d-none');
                        b2g1.variables.type = 'b2g1';

                        $('.b2g1-buy-card .top h2').html('Buy 2 - Get 1 Free');

                        

                    break;
                    case 3:
                        $('#btn-checkout span').html('Upgrade To Buy 3 Get 2 Free');
                        $('#btn-checkout-b2g1').fadeIn();
                        $('#btn-checkout').addClass('active');

                        $('.b2g1-add-on').fadeIn();

                        
                    break;
                    case 4:
                        $('#btn-checkout span').html('Add 1 More To Unlock Your Free Product');
                        $('.b2g1-add-on').fadeIn();

                     


                    break;
                    case 5:
                        $('#btn-checkout span').html('Lock In My Limited Time Deal');
                        $('#btn-checkout').addClass('b3g2 active');

                        $('.b2g1-add-on').fadeIn();

                    break;
                }


                b2g1.initializeSelections();

            });

        },
        initializeSelections: function(){
            console.log('x b2g1.variables.selection', b2g1.variables.selection);


            var chosenProduct = 1;
            
            // $('.chosen-products [data-product]').find('img').remove();

            $('.chosen-products [data-product]').each(function(){
                $(this).find('span').html($(this).attr('data-original'));
                $(this).attr('data-variant-id','').attr('data-variant-price','').removeClass('active');
            });

            $.each(b2g1.variables.selection, function(variantId, qty) {
                console.log('variantId', variantId, 'qty', qty);


                var productItem = $('.product-item[data-variant-id="' + variantId + '"]');
                var productName = productItem.find('.text h4').text();
                var image = productItem.find('.product-image').clone();
                var imageSRC = productItem.find('.product-image').attr('src');

                for (i = 0; i < qty; i++){
                    var choseProductElement = $('.chosen-products [data-product="'+chosenProduct+'"]');
                    choseProductElement.find('span').text(productName);

                    if (!choseProductElement.find('img').length){
                        choseProductElement.find('span').after(image);
                    }else{
                        choseProductElement.find('img').attr('src',imageSRC);
                    }
                    
                    choseProductElement.attr('data-variant-id', variantId).addClass('active');
                    choseProductElement.attr('data-variant-price', productItem.data('variant-price'));
                    chosenProduct++;
                }


                // $('.chosen-products [data-product]').each(function(index) {
                //     $(this).find('span').text(productName);
                //     $(this).attr('data-variant-id', variantId);
                // });
            });
        },
        countTotalQty: function(){

            var totalQty = 0;
            $('.product-item-eligible').each(function() {
                const $item = $(this);
                const $qtyValue = $item.find('.qty-value').html();
                totalQty+= parseInt($qtyValue);
            });

            return totalQty;
        }
    }

    b2g1.init();

    var animated = false;

    function animateBars() {
        if (animated) return;
        animated = true;

        if ($(window).width() >= 768) {
            $('.bar-yellow').css('width', '30%'); // desktop
        } else {
            $('.bar-yellow').css('width', '60%'); // mobile
        }

        // setTimeout(function () {
            $('.bar-grey').css('width', '100%');
        // }, 1500);
    }

    var $section = $('.section-unicorn-math');

    if (!$section.length) return;

    if ('IntersectionObserver' in window) {

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    animateBars();
                    observer.disconnect();
                }
            });
        }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

        observer.observe($section[0]);

    } else {

        $(window).on('scroll.mathbars', function () {
            var top = $section[0].getBoundingClientRect().top;
            if (top < window.innerHeight - 50) {
                animateBars();
                $(window).off('scroll.mathbars');
            }
        }).trigger('scroll.mathbars');

    }

     // Build a SKU → variant ID map from the lookup divs
    const skuMap = {};
    $('.change-variant-id[data-variant-sku]').each(function () {
        skuMap[$(this).data('variant-sku')] = $(this).data('variant-id');
    });

    // Loop every product-item and set the regular variant ID
    $('.product-item[data-variant-sku]').each(function () {
        const sku = $(this).data('variant-sku');
        if (skuMap[sku]) {
            $(this).attr('data-regular-product-variant-id', skuMap[sku]);
        }
    });


    // function openHesitationPopup() {
    //     $.magnificPopup.open({
    //         items: {
    //             src: '#hesitation-popup',
    //             type: 'inline'
    //         },
    //         mainClass: 'mfp-hesitation',
    //         removalDelay: 300,
    //         callbacks: {
    //             open: function () {
    //                 // Optional animation
    //             }
    //         }
    //     });
    // }

    // if (window.location.hash === '#times-up') {
    //         openHesitationPopup();
    // }

    var originalAdBtn;

    $(document).on('click','.ab-btn',function(){
        

        if (!originalAdBtn){
            originalAdBtn = $(this).html();
        }
        
        $(this).toggleClass('active');

        if ($(this).hasClass('active')){
            $(this).html('<span class="remove">Remove</span>');
        }else{
            $(this).html(originalAdBtn);
        }
    });


    function buildCheckoutItems(selection) {
        // Build flat list of all items with price — in DOM order
        var allItems = [];

        $('.product-item-eligible').each(function () {
            var variantId = $(this).attr('data-variant-id');

            if (!selection[variantId]) return;

            var $product = $(this);
            var image    = $product.find('.product-image').attr('src');
            var name     = $product.find('.text h4').text();
            var price    = parseInt($product.attr('data-variant-price')) / 100;
            var qty      = selection[variantId];
            var serves   = parseInt($product.attr('data-variant-serves')) || 20;

            for (var i = 0; i < qty; i++) {
                allItems.push({ variantId, image, name, price, qty, serves });
            }
        });

        // Sort by price asc, then qty asc — least qty at same price = free
        var sorted    = [...allItems].sort(function (a, b) {
            if (a.price !== b.price) return a.price - b.price;
            return a.qty - b.qty;
        });

        var freeCount = b2g1.variables.type === 'b3g2' ? 2 : 1;
        var freeItems = sorted.slice(0, freeCount);

        // Build freeQuota per variantId
        var freeQuota = {};
        freeItems.forEach(function (item) {
            freeQuota[item.variantId] = (freeQuota[item.variantId] || 0) + 1;
        });

        var freeSaving = freeItems.reduce(function (sum, item) { return sum + item.price; }, 0);

        // Split into paid and free
        var freeUsed     = {};
        var paidItems    = [];
        var freeItemRows = [];

        allItems.forEach(function (item) {
            freeUsed[item.variantId] = freeUsed[item.variantId] || 0;

            var allowed = freeQuota[item.variantId] || 0;
            var isFree  = freeUsed[item.variantId] < allowed;

            if (isFree) {
                freeUsed[item.variantId]++;
                freeItemRows.push(item);
            } else {
                paidItems.push(item);
            }
        });

        // Render paid first, free last, one row per flavour (2026-10-19, on request:
        // "no scroll"). It was one row per pouch, so Buy 3 Get 2 stacked five rows
        // and the popup scrolled; grouped it is at most four (2 flavours x paid/free).
        function groupRows(list, isFree) {
            var byId = {}, order = [];
            list.forEach(function (item) {
                if (!byId[item.variantId]) { byId[item.variantId] = { item: item, count: 0, isFree: isFree }; order.push(item.variantId); }
                byId[item.variantId].count++;
            });
            return order.map(function (id) { return byId[id]; });
        }
        var rows = groupRows(paidItems, false).concat(groupRows(freeItemRows, true));

        var itemsHtml = rows.map(function (row) {
            var item = row.item, isFree = row.isFree, count = row.count;

            return `
                <div class="cp-item ${isFree ? 'cp-item--free' : ''}">
                    <span class="cp-item-media">
                        <img src="${item.image}" alt="${item.name}" class="cp-item-img" />
                        ${count > 1 ? `<span class="cp-item-qty">${count}</span>` : ''}
                    </span>
                    <div class="cp-item-info">
                        <strong>${item.name}${count > 1 ? ` <em>&times;${count}</em>` : ''}</strong>
                        <span>${isFree
                            ? 'Pay Nothing | Limited Time Deal'
                            : (count > 1 ? count + ' &times; ' : '') + '<c class="with-currency-code"></c>' + item.price.toFixed(2)
                        }</span>
                    </div>
                    <div class="cp-item-badge ${isFree ? 'cp-item-free-label' : 'cp-item-check'}">
                        ${isFree
                            ? 'FREE'
                            : `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0051ff" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>`
                        }
                    </div>
                </div>
            `;
        }).join('');

        // Add-on bundle row
        var addonTotal = 0;
        if ($('.ab-btn').hasClass('active')) {
            var $abBtn      = $('.ab-btn');
            var bottlePrice = parseFloat($abBtn.attr('data-variant-price') || 0);
            var frothPrice  = parseFloat($abBtn.attr('data-variant-price-frother') || 0);
            addonTotal      = bottlePrice + frothPrice;

            itemsHtml += `
                <div class="cp-item cp-item--addon">
                    <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/bottle_frother-thumbnail.png?v=1782173144" alt="Accessories Bundle" class="cp-item-img" />
                    <div class="cp-item-info">
                        <strong>Accessories Bundle</strong>
                        <span>1x Premium Bottle, 1x Frother Bottle</span>
                    </div>
                    <div class="cp-item-badge cp-item-addon-price with-currency-code">
                        ${addonTotal.toFixed(2)}
                    </div>
                </div>
            `;
        }

        // Total = all items - free savings + addon
        var allTotal  = allItems.reduce(function (sum, item) { return sum + item.price; }, 0);
        var paidTotal = allTotal - freeSaving + addonTotal;

        $('.cp-items').html(itemsHtml);
        $('.cp-saving-amount').text(freeSaving.toFixed(2));
        $('.cp-checkout-total').html(paidTotal.toFixed(2));



        // Per day = what is paid over every serve in the order. The cards carry
        // their serves (data-variant-serves: 56 for a OneFit 4.7 pouch, since
        // 2026-10-15); this was a flat 60 / 100, three or five 20-serve units.
        var totalServes = allItems.reduce(function (sum, item) { return sum + item.serves; }, 0) || 1;
        var perServe = (allTotal - freeSaving) / totalServes;
        $('.cp-badge').html('Buy 2 - <span>Get 1 Free</span>');

        if (b2g1.variables.type == 'b3g2'){
            $('.cp-badge').html('Buy 3 - <span>Get 2 Free</span>');
        }

        // alert(allTotal + ' ' + perServe);
        $('.per-serve-value').html(perServe.toFixed(2));

    }

    function checkoutNow($btn){

        var originalText = $btn.html();

        // Show loading state
        $btn.find('.inner').html('Please wait...');
        $btn.prop('disabled', true);
        

        setTimeout(function(){
            $btn.html(originalText);
            $btn.prop('disabled', false);
        },500);


        var selection = b2g1.variables.selection;
        var lineItems = Object.keys(selection).map(function (variantId) {
            return {
                id: parseInt(variantId),
                quantity: selection[variantId],
                properties: {
                    '_order_from': b2g1.variables.type
                }
            };
        });

        if ($('.ab-btn').hasClass('active')) {
            var variantBottleId = $('.ab-btn').data('variant-id');
            var variantFrotherId = $('.ab-btn').data('variant-id-frother');

            lineItems.push(
                { id: parseInt(variantBottleId), quantity: 1, properties: { '_order_from': b2g1.variables.type } },
                { id: parseInt(variantFrotherId), quantity: 1, properties: { '_order_from': b2g1.variables.type } }
            );
        }

        // Checkout
        // Step 1: Clear the cart first
        $.ajax({
            url: '/cart/clear.js',
            type: 'POST',
            success: function () {

                // Step 2: Add B2G1 items
                $.ajax({
                    url: '/cart/add.js',
                    type: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify({ items: lineItems }),
                    success: function () {
                        // Step 3: Redirect with discount code
                        window.location.href = '/checkout';

                          $btn.html(originalText);
                        $btn.prop('disabled', false);

                    },
                    error: function (err) {
                        console.error('Cart add failed:', err);
                        $btn.html(originalText);
                        $btn.prop('disabled', false);
                    }
                });

            },
            error: function (err) {
                console.error('Cart clear failed:', err);
                $btn.html(originalText);
                $btn.prop('disabled', false);
            }
        });
    }
   

});
});
